var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pricelist"},[_c('p',[_vm._v(_vm._s(_vm.$t('pricelist.title'))),_c('a',{attrs:{"href":"https://www.takstsenteret.no/prisliste","target":"_blank"}},[_vm._v("Takstsenteret")])])])}
var staticRenderFns = []

export { render, staticRenderFns }